module.exports = __webpack_public_path__ + "img/table.c46a6a40.png";